import React from "react";

import DashboardFeature from "../features/dashboard";

function Dashboard(props) {
  return <DashboardFeature {...props} />;
}

export default Dashboard;
